import React from "react";
import { motion } from "framer-motion";

export default function Card({ children }) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="rounded-xl bg-slate-50 dark:bg-slate-900 shadow-sm ring-1 ring-slate-200/70 dark:ring-slate-700 p-5 transition-transform"
    >
      {children}
    </motion.div>
  );
}
